import { Helmet } from "react-helmet";
import { musicData, newsPosts, upcomingConcerts } from "../../constants";
import "./Home.css";
import { useState } from "react";
import MusicPlayer from "./MusicPlayer";
import { MusicCard, NewsPost, Concert } from "../../interfaces/interfaces";

const Home = () => {
  const [activePlayer, setActivePlayer] = useState<string | null>(null);
  const [selectedCard, setSelectedCard] = useState<MusicCard | null>(null);
  const [selectedNewsPost, setSelectedNewsPost] = useState<NewsPost | null>(null);
  const [selectedConcert, setSelectedConcert] = useState<Concert | null>(null);

  // Sort concerts by date (newest first)
  const sortedConcerts = [...upcomingConcerts].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );
  // Sort news posts by date (newest first)
  const sortedNewsPosts = [...newsPosts].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );

  return (
    <div className="home-container">
      <Helmet>
        <title>Home | Zied Zouari</title>
      </Helmet>
      <main className="main-content">

        {/* Responsive Image */}
        {/* <div className="header-image-container">
          <img src="/bk.webp" alt="Header" className="header-image" />
        </div> */}
<div className="header-video-container">
  {/* Squared Video for Mobile Devices */}
  <video
    className="header-video squared-video"
    autoPlay
    loop
    muted
    playsInline
  >
    <source src="/squared-video.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>

  {/* Rectangular Video for PCs and Big Tablets */}
  <video
    className="header-video rectangular-video"
    autoPlay
    loop
    muted
    playsInline
  >
    <source src="/rectangular-video.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
</div>
        <div className="intro-section">
          <h1>
            ZIED ZOUARI <br />
            Violoniste & Compositeur
          </h1>
        </div>
        
        <div className="content-wrapper">
          <div className="details-section">
            <div className="music-section">
              {musicData.map((music, index) => (
                <div className="detail-card" key={"music: " + index}>
                  <h3>{music.title}</h3>
                  {/* Audio Player */}
                  <MusicPlayer
                    soundPath={music.soundPath}
                    isActive={activePlayer === music.id}
                    onPlay={() => setActivePlayer(music.id)}
                    onPause={() => setActivePlayer(null)}
                  />
                  <button
                    className="about-button"
                    onClick={() => setSelectedCard(music)}
                  >
                    {music.about}
                  </button>
                </div>
              ))}
            </div>

            <div className="details-section">
              <div className="blog-header">
                <h2>Prochains Concerts</h2>
              </div>

              {/* Concert List Section */}
              <div className="concert-list-section">
                <ul className="concert-list">
                  {sortedConcerts.map((concert) => (
                    <li key={concert.id} className="concert-item">
                      <div onClick={() => setSelectedConcert(concert)}>
                        <h3>{concert.title}</h3>
                        <p>
                          <strong>Date:</strong> {concert.date}
                        </p>
                        <p>
                          <strong>Lieu:</strong> {concert.location}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="details-section">
              <div className="blog-header">
                <h2>Actualités</h2>
              </div>
              {/* News List Section */}
              <div className="news-list-section">
                <ul className="news-list">
                  {sortedNewsPosts.slice(0, 2).map((post) => (
                    <li
                      key={post.id}
                      className="news-item"
                      onClick={() => setSelectedNewsPost(post)}
                    >
                      <img
                        src={post.imageUrl}
                        alt={post.title}
                        className="news-image"
                      />
                      <div className="item-content">
                        <h3>{post.title}</h3>
                        <p>
                          <strong>Date:</strong> {post.date}
                        </p>
                        <p>
                          <strong>Catégorie:</strong> {post.category}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Modals */}
        {selectedCard && (
          <div className="modal-overlay" onClick={() => setSelectedCard(null)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button
                className="close-modal"
                onClick={() => setSelectedCard(null)}
              >
                ×
              </button>
              <h2>{selectedCard.title}</h2>
              <p>{selectedCard.description}</p>
              <button
                className="category-tag"
                onClick={() => window.open(selectedCard.link, "_blank")}
              >
                Ecouter {selectedCard.title} sur Spotify
              </button>
            </div>
          </div>
        )}
        {selectedNewsPost && (
          <div
            className="modal-overlay"
            onClick={() => setSelectedNewsPost(null)}
          >
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button
                className="close-modal"
                onClick={() => setSelectedNewsPost(null)}
              >
                ×
              </button>
              <div className="modal-image-container">
                <img
                  src={selectedNewsPost.imageUrl}
                  alt={selectedNewsPost.title}
                  className="modal-image"
                />
              </div>
              <h2>{selectedNewsPost.title}</h2>
              <p>{selectedNewsPost.description}</p>
            </div>
          </div>
        )}
        {selectedConcert && (
          <div
            className="modal-overlay"
            onClick={() => setSelectedConcert(null)}
          >
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button
                className="close-modal"
                onClick={() => setSelectedConcert(null)}
              >
                ×
              </button>
              <h2>{selectedConcert.title}</h2>
              <p>
                <strong>Date:</strong> {selectedConcert.date}
              </p>
              <p>
                <strong>Lieu:</strong> {selectedConcert.location}
              </p>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default Home;